import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

// Custom hook to track page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const url = window.location.origin + location.pathname + location.search;
    const title = document.title;
    
    // Small delay to ensure the page title is updated
    setTimeout(() => {
      trackPageView(url, document.title || title);
    }, 100);

  }, [location]);

  return null;
};

export default usePageTracking;
 